import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { portalApi } from '@/lib/portalApi';
import '@/styles/portal.css';

const NAV_ITEMS = [
  { to: '/portal', label: 'Accueil', icon: '⌂', exact: true },
  { to: '/portal/projects', label: 'Projets', icon: '◫' },
  { to: '/portal/messages', label: 'Messages', icon: '✉' },
  { to: '/portal/invoices', label: 'Factures', icon: '◙' },
  { to: '/portal/profile', label: 'Profil', icon: '◉' },
];

export default function PortalLayout() {
  const navigate = useNavigate();

  const { data: notifications } = useQuery({
    queryKey: ['portal', 'notifications'],
    queryFn: portalApi.getNotifications,
    refetchInterval: 60_000,
  });

  const unreadCount = notifications?.filter((n) => !n.isRead).length ?? 0;

  const handleLogout = async () => {
    await portalApi.logout();
    navigate('/portal/login');
  };

  return (
    <div className="p-shell">
      {/* Mobile header */}
      <header className="p-header">
        <span className="p-header-logo">ELBAHI</span>
        <div className="p-header-actions">
          <button className="p-notif-btn" onClick={() => navigate('/portal')}>
            <span style={{ fontSize: 20 }}>🔔</span>
            {unreadCount > 0 && (
              <span className="p-notif-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
            )}
          </button>
          <NavLink to="/portal/profile">
            <div className="p-avatar">P</div>
          </NavLink>
        </div>
      </header>

      {/* Desktop sidebar */}
      <aside className="p-sidebar">
        <div className="p-sidebar-logo">ELBAHI</div>
        <nav className="p-sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                `p-sidebar-nav-item${isActive ? ' active' : ''}`
              }
            >
              <span style={{ fontSize: 18, width: 24, textAlign: 'center' }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
          <NavLink
            to="/portal/tickets"
            className={({ isActive }) =>
              `p-sidebar-nav-item${isActive ? ' active' : ''}`
            }
          >
            <span style={{ fontSize: 18, width: 24, textAlign: 'center' }}>🎫</span>
            Tickets
          </NavLink>
          <NavLink
            to="/portal/reports"
            className={({ isActive }) =>
              `p-sidebar-nav-item${isActive ? ' active' : ''}`
            }
          >
            <span style={{ fontSize: 18, width: 24, textAlign: 'center' }}>📊</span>
            Rapports
          </NavLink>
        </nav>
        <div className="p-sidebar-footer">
          <button
            onClick={handleLogout}
            style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: 12 }}
          >
            ⏻ Déconnexion
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="p-content">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav className="p-bottom-nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.exact}
            className={({ isActive }) =>
              `p-bottom-nav-item${isActive ? ' active' : ''}`
            }
          >
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
